import { TextStyle } from '@ticketmaster/global-design-system';
import React from 'react';
import { TicketAdditionalInfo, TicketModel } from '@/v2/models/ticketModel';

function formatAdditionalInfo(data: TicketAdditionalInfo) {
  return (
    <div key={data.key} style={{ textAlign: 'left' }}>
      <TextStyle.Etna>{data.value}</TextStyle.Etna>
    </div>
  );
}

export function getAdditionalInfos(ticket: TicketModel, isFrontOfTicket: boolean) {
  return ticket.additionalInfos
    .filter((data: TicketAdditionalInfo) => (isFrontOfTicket ? data.showInFront : data.showInBack) && data.value)
    .sort((a: TicketAdditionalInfo, b: TicketAdditionalInfo) => a.index - b.index)
    .map(formatAdditionalInfo);
}
